export const MULTICITY = "multicity";
export const ONEWAY = "oneway";
export const ROUNDTRIP = "roundtrip";
